module.exports = __webpack_public_path__ + "static/media/image_part_001.6c1a6720.jpg";